import React from "react";
import Sidebar from "../../../components/layout/Sidebar/Sidebar";
import Navbar from "../../../components/layout/Navbar/Navbar";
import { Outlet } from "react-router-dom";
import styles from "./AdminDashboard.module.css";
import useAuthGuard from "../../../hooks/useAuthGuard";

const AdminDashboard = () => {
  useAuthGuard();
  return (
    <div className={styles.dashboardContainer}>
      <Sidebar isCustomer={false} />
      <div className={styles.mainContent}>
        <Navbar />
        <Outlet />
      </div>
    </div>
  );
};

export default AdminDashboard;
